/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_NavInputs */

const en_road_nav = /** @type {(inputs: Road_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit the Road Dude AI`)
};

/**
* | output |
* | --- |
* | "Hit the Road Dude AI" |
*
* @param {Road_NavInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const road_nav = /** @type {((inputs?: Road_NavInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_NavInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_road_nav(inputs)
});
export { road_nav as "road.nav" }